import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ai-agents" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Agent = _resolveComponent("Agent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.persona)
      ? (_openBlock(), _createBlock(_component_Agent, {
          key: 0,
          type: "persona",
          flat: $props.flat
        }, null, 8 /* PROPS */, ["flat"]))
      : _createCommentVNode("v-if", true),
    ($options.company)
      ? (_openBlock(), _createBlock(_component_Agent, {
          key: 1,
          type: "market-intelligence",
          flat: $props.flat
        }, null, 8 /* PROPS */, ["flat"]))
      : _createCommentVNode("v-if", true),
    ($options.editable)
      ? (_openBlock(), _createBlock(_component_Agent, {
          key: 2,
          type: "post-writer",
          flat: $props.flat
        }, null, 8 /* PROPS */, ["flat"]))
      : _createCommentVNode("v-if", true),
    ($options.meeting)
      ? (_openBlock(), _createBlock(_component_Agent, {
          key: 3,
          type: "meeting-prep",
          flat: $props.flat
        }, null, 8 /* PROPS */, ["flat"]))
      : _createCommentVNode("v-if", true),
    ($options.nothing)
      ? (_openBlock(), _createBlock(_component_Agent, {
          key: 4,
          type: "genrate",
          flat: $props.flat
        }, null, 8 /* PROPS */, ["flat"]))
      : _createCommentVNode("v-if", true)
  ]))
}